<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

        <h1>Agenda geração de arquivo completo do processo</h1>
      
<div class="container text-right" style="text-align: right; font-size: small;">
    <div class="row">
        <div class="col-12">
            <button @click="Voltar();"><u>V</u>oltar</button>&nbsp;&nbsp;
            <button @click="GerarArquivoCompleto();"><u>G</u>erar Arquivo Completo</button>

        </div>
    </div>
</div>

        <p>Processo: {{ processo.codigo_processo }}</p>
    
        <p>Quando for concluído a geração, um email será enviado com as informações que estão cadastradas para</p>

        <h5>{{ user.email }}</h5>

        <p>Se desejar alterar o cadastro, acesse o menu Usuários, <u>Alteração de dados pessoais</u>.</p>

        <p class="centro">
            Verifique os processos (principal e relacionados) que deseja baixar. <br /> Caso desejar, desmarque os processos que NÃO deseja baixar.
        </p>

        <p class="centro">
            ***** ATENÇÃO ***** <br />
            Documentos HTML e PDF mal geradores e/ou mal formatados, podem fazer com que a rotina não consiga fazer a importação para o arquivo único podendo causar erro durante o processamento. <br />
            A opção de Reduzir a Qualidade do PDF pode, em alguns casos, gerar erro e interromper o download completo. <br />
            A opção de Especificar o tamanho máximo dos arquivos pode ocasionar erros se o tamanho escolhido for muito pequeno, isso vai depender do tamanho individual dos arquivos de cada processo.
        </p>
        <p class="centro">
            Todos os documentos serão agrupados em um único arquivo, desde que este ão ultrapasse 50 MB. <br />
            Caso este limite seja ultrapassado, o arquivo para download será dividivo em partes. <br />
            Esta operação pode demorar vários minutos, dependendo da quantidade de documentos nos processos.
        </p>
        <p class="centro">
            IMPORTANTE: A funcionalidade de Download Completo é apenas um recurso ADICIONAL do sistema, disponibilizado para FACILITAR a leitura dos autos do processo. Aíntegra do processo (incluindo TODOS os seus documentos) está sempre disponível, a qualquer horário, através do acesso normal ao sistema eproc. Por se tratar de um recurso adicional, sua eventual indisponibilidade não obriga a Justiça Estadual a fornecer cópia dos autos na forma impressa ou em meio eletrônico.
        </p>
        
        <div class="container">

            <div class="row">
                <div class="col-6">
                    <div class="form-container mb-3" style="font-size: small;">
                        <div class="form-title">Opções de geração:</div>
                        <ul style="list-style-type: none;">
                            <li><input type="checkbox" id="add_todos_eventos_capa_processo" v-model="add_todos_eventos_capa_processo"> Adicionar lista com todos os eventos incluídos no download na capa do processo</li>
                            <li><input type="checkbox" id="incluir_anexos" v-model="incluir_anexos"> Incluir anexos eletrônicos</li>
                            <li><input type="checkbox" id="reduzir_qualidade_anexos" v-model="reduzir_qualidade_anexos"> Reduzir a qualidade das imagens do PDF gerado (reduz o tamanho do arquivo final)</li>
                            <li><input type="checkbox" id="especificar_tamanho_arquivos" v-model="especificar_tamanho_arquivos"> Especificar tamanho máximo dos arquivos</li>
                        </ul>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-container mb-3" style="font-size: small;">
                        <div class="form-title">Filtros:</div>

                        <ul style="list-style-type: none;">
                            <li><input type="checkbox" id="filtro_so_eventos" v-model="filtro_so_eventos"> Trazer só eventos com documentos</li>
                            <li><input type="checkbox" id="filtro_eventos_decisao" v-model="filtro_eventos_decisao"> Trazer só eventos de decisão</li>
                            <li><input type="checkbox" id="filtro_eventos_externos" v-model="filtro_eventos_externos"> Trazer só eventos externos</li>
                            <li><input type="checkbox" id="filtro_data_inicio" v-model="filtro_data_inicio"> Trazer somente eventos a partir de uma data: <input type="date" id="data_inicio_eventos" style="width: 100px;" v-model="data_inicio_eventos" /> </li>
                            <li><input type="checkbox" id="filtro_evento_inicio" v-model="filtro_evento_inicio"> Trazer do processo principal apenas os eventos de: <input type="text" id="apenas_eventos_diante" style="width: 60px;" v-model="apenas_eventos_diante" /> em diante (ex: de 500 em diante)</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <p style="text-align: right; color: lightgray; font-size: small;">Lista de Processos (1 registro):</p>
                    <table class="table table-striped table-bordered border" style="font-size: small;" v-if="processo" id="printable-section">
                        <thead>
                            <tr class="text-center">
                                <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                <th scope="col" style="background-color: lightgrey;">Nº Processo</th>
                                <th scope="col" style="background-color: lightgrey;">Tipo</th>
                                <th scope="col" style="background-color: lightgrey;">UF</th>
                                <th scope="col" style="background-color: lightgrey;">Classe</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td style="text-align: left; display: none;"> {{ processo.id }}</td>
                                <td style="text-align: left;"><input type="checkbox" checked v-model="numero_processo_checado"> {{ processo.codigo_processo }}</td>
                                <td style="text-align: left;">Principal</td>
                                <td style="text-align: left;">RS</td>
                                <td style="text-align: left;">{{ processo.classe_processual.descricao }}</td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>





        </div>


    </div>
  </template>
  
<script>
  
export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            add_todos_eventos_capa_processo: '',
            incluir_anexos: '',
            reduzir_qualidade_anexos: '',
            especificar_tamanho_arquivos: '',
            filtro_so_eventos: '',
            filtro_eventos_decisao: '',
            filtro_eventos_externos: '',
            filtro_data_inicio: '',
            data_inicio_eventos: '',
            filtro_evento_inicio: '',
            apenas_eventos_diante: '',
            numero_processo_checado: true,

        };
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        processo: {
            type: Object,
        },
    },
    methods: {
        Voltar(){
            window.location.href = this.BASE_URL + "processos/movimentacao_processual/" + this.processo.id;
        },
        GerarArquivoCompleto() {
            const payload = {
                processo_id: this.processo.id,
                add_todos_eventos_capa_processo: this.add_todos_eventos_capa_processo,
                incluir_anexos: this.incluir_anexos,
                reduzir_qualidade_anexos: this.reduzir_qualidade_anexos,
                especificar_tamanho_arquivos: this.especificar_tamanho_arquivos,
                filtro_so_eventos: this.filtro_so_eventos,
                filtro_eventos_decisao: this.filtro_eventos_decisao,
                filtro_eventos_externos: this.filtro_eventos_externos,
                filtro_data_inicio: this.filtro_data_inicio,
                data_inicio_eventos: this.data_inicio_eventos,
                filtro_evento_inicio: this.filtro_evento_inicio,
                apenas_eventos_diante: this.apenas_eventos_diante,
                numero_processo_checado: this.numero_processo_checado,
            };

            let url = this.BASE_URL + "processos/movimentacao_processual/download";

            axios.post(url, payload, {
                responseType: 'blob'
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "arquivo_completo_"+this.processo.id+".pdf"); // Nome do arquivo que será baixado
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                console.error('Erro ao gerar arquivo:', error);
            });
        },
    },
    mounted() {

    },
};
</script>
  
<style scoped>
h1{
    font-size: 26px;
}

p{
    font-size: small;
}

.centro{
    text-align: center;
}

.form-container {
    border: 1px solid gray; 
    padding: 10px;
    position: relative; 
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    /* background-color: #FFFFFF;  */
}

.form-title {
    position: absolute;
    top: -12px;
    left: 10px;
    background: #F7FAF9;
    padding: 0 3px;
    /* font-weight: bold;  */
}

li {
    text-decoration: underline;
}

</style>
  
